import React, {useRef, useState} from 'react'
import WizImage from '../../../components/image/WizImage'
import Text from '../../../components/text/Text'
import {useTime} from '../../../utils/time'
import {copyToClipboard, useTag} from '../../../utils/etc'
import {useImage} from '../../../utils/image'
import ic_icon_trash from '../../../assets/images/icon_trash.png'
import ic_icon_edit from '../../../assets/images/icon_edit.png'
import ic_edit from '../../../assets/images/icon_edit.png'
import WizSwitchButton from '../../../components/button/WizSwitchButton'
import Span from '../../../components/text/Span'
import RemoveThumbnailModal from './RemoveThumbnailModal'
import ChangedNicknameModal from './ChangedNicknameModal'
import ChangedStatusMessageModal from './ChangedStatusMessageModal'
import WizButton from '../../../components/button/WizButton'
import {postEditUser} from '../../../apis/user/editUser'
import {IUserData} from '../../../apis/user/getUserDetail'
import WizTag from '../../../components/tag/WizTag'
import useNavigation from '../../../hooks/useNavigation'
import {useString} from '../../../utils/string'
import ChangedUserReferralModal from './ChangedUserReferralModal'
import ChangedKoreanNicknameModal from './ChangedKoreanNicknameModal'
import {useDisplayNumber} from '../../../utils/number'
import ChangedUsedReferralCodeModal from './ChangedUsedReferralCodeModal'
import UsedMyReferralCodeList from './UsedMyReferralCodeList'
import UserPointHistoryModal from './UserPointHistoryModal'
import UserActiveLeagueModal from './UserActiveLeagueModal'
import useDidMountEffect from '../../../hooks/useDidMountEffect'
import UserTradermapModal from './UserTradermapModal'

interface IProps {
    className?: string
    data?: IUserData
    refetch?: () => void
}

const UserInfoContainer: React.FC<IProps> = ({className, data, refetch}) => {
    const {localTimeString, convertUtc0ToUtc9} = useTime()
    const {renderNetworkBgColor, renderPrivacyLevel} = useTag()
    const {renderThumbnail} = useImage()
    const {goUserDetail} = useNavigation()
    const {shortCutString} = useString()
    const {floorBalance} = useDisplayNumber()

    const [editMode, setEditMode] = useState(false)

    const changedNicknameModalRef = useRef<any>()
    const changedKoreanNicknameModalRef = useRef<any>()
    const changedStatusMessageModalRef = useRef<any>()
    const RemoveThumbnailRef = useRef<any>()
    const referralEditModalRef = useRef<any>()
    const changedUsedReferralCodeModalRef = useRef<any>()
    const usedMyReferralCodeRef = useRef<any>()
    const pointHistoryModalRef = useRef<any>()
    const userActiveLeagueModalRef = useRef<any>()
    const tradermapModalRef = useRef<any>()

    useDidMountEffect(() => {
        refetch()
    }, [data])

    const onClickShadowBan = async () => {
        await postEditUser({id: data?.id, is_filtered: !data?.is_filtered})
        refetch()
    }

    const renderUserType = type => {
        if (type === 0) {
            return 'Default'
        } else if (type === 1) {
            return 'Official'
        } else if (type === 2) {
            return 'Influence'
        } else {
            return 'Need Checked'
        }
    }

    return (
        <>
            <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
                <div
                    className={
                        'flex justify-between space-x-[20px] sm:flex-col sm:justify-center sm:items-center sm:space-x-[0px]'
                    }>
                    <div className={'flex items-center space-x-[10px] sm:flex-col sm:space-x-[0px] sm:gap-[10px]'}>
                        <div className={'relative flex-none'}>
                            <WizImage
                                src={renderThumbnail(data?.thumbnail)}
                                className={`w-[80px] h-[80px] rounded-full ${
                                    data?.is_pro && 'border-[2px] p-[2px] border-font_pro'
                                }`}
                            />
                            {data?.thumbnail && editMode && (
                                <div
                                    onClick={() => {
                                        RemoveThumbnailRef.current.show()
                                    }}
                                    className={
                                        'absolute bottom-0 right-0 bg-white rounded-full border border-line01 p-[3px] cursor-pointer'
                                    }>
                                    <WizImage src={ic_icon_trash} className={'w-[16px]'} />
                                </div>
                            )}
                        </div>
                        <div className={'sm:pb-[20px]'}>
                            <div className={'flex items-center space-x-[5px] sm:pb-[10px]'}>
                                <div className={'flex items-center space-x-[10px]'}>
                                    <Text
                                        onClick={() => copyToClipboard(data?.name)}
                                        className={'text-h3 cursor-pointer'}>
                                        {data?.name}
                                    </Text>
                                    {editMode && (
                                        <WizImage
                                            onClick={() => changedNicknameModalRef.current.show()}
                                            src={ic_icon_edit}
                                            className={
                                                'w-[20px] bg-white border border-line01 cursor-pointer rounded-full'
                                            }
                                        />
                                    )}
                                    {data?.nicknames?.find(item => item.language === 'ko')?.nickname && (
                                        <>
                                            <div className={'w-[1px] bg-line01 h-[20px]'} />

                                            <Text
                                                onClick={() =>
                                                    copyToClipboard(
                                                        data?.nicknames?.find(item => item.language === 'ko')?.nickname,
                                                    )
                                                }
                                                className={'text-h3 cursor-pointer'}>
                                                {data?.nicknames?.find(item => item.language === 'ko')?.nickname}
                                            </Text>
                                        </>
                                    )}
                                </div>
                                {editMode && (
                                    <WizImage
                                        onClick={() => changedKoreanNicknameModalRef.current.show()}
                                        src={ic_icon_edit}
                                        className={'w-[20px] bg-white border border-line01 cursor-pointer rounded-full'}
                                    />
                                )}
                                {data?.is_pro && (
                                    <div className={'flex items-center gap-x-[10px] md:hidden'}>
                                        <div className={'bg-gradient_pro px-[5px] py-[1px] rounded-[3px]'}>
                                            <Text className={'text-ti3 text-white'}>PRO</Text>
                                        </div>
                                        <div>
                                            <Text className={'text-ti2 text-bg_pro_gradient02'}>
                                                Until : {convertUtc0ToUtc9(data?.pro_until)}
                                            </Text>
                                        </div>
                                    </div>
                                )}
                                {data?.is_filtered && (
                                    <div className={'bg-shadow_ban px-[5px] py-[1px] rounded-[3px] md:hidden'}>
                                        <Text className={'text-ti3 text-white'}>Ban</Text>
                                    </div>
                                )}
                            </div>
                            <div className={'hidden md:block'}>
                                {data?.is_pro && (
                                    <div className={'flex items-center gap-x-[10px] sm:flex-col sm:gap-[5px]'}>
                                        <div className={'bg-gradient_pro px-[5px] py-[1px] rounded-[3px]'}>
                                            <Text className={'text-ti3 text-white'}>PRO</Text>
                                        </div>
                                        <div>
                                            <Text className={'text-ti2 text-bg_pro_gradient02'}>
                                                Until : {convertUtc0ToUtc9(data?.pro_until)}
                                            </Text>
                                        </div>
                                    </div>
                                )}
                                {data?.is_filtered && (
                                    <div
                                        className={
                                            'bg-shadow_ban px-[5px] py-[1px] rounded-[3px] w-min my-[5px] sm:mx-auto'
                                        }>
                                        <Text className={'text-ti3 text-white'}>Ban</Text>
                                    </div>
                                )}
                            </div>
                            <div>
                                <Text
                                    onClick={() => copyToClipboard(data?.id)}
                                    className={'text-body3 text-font03 cursor-pointer sm:text-center'}>
                                    ({data?.id})
                                </Text>
                            </div>
                            <div
                                className={
                                    'flex-col items-center space-x-[5px] sm:justify-center sm:flex-col-reverse mt-[10px]'
                                }>
                                <Text className={'text-font02 text-body2 font-sans sm:text-center'}>
                                    {data?.status}
                                </Text>
                                {editMode && (
                                    <WizImage
                                        onClick={() => changedStatusMessageModalRef.current.show()}
                                        src={ic_icon_edit}
                                        className={
                                            'w-[20px] bg-white border border-line01 cursor-pointer rounded-full sm:mt-[10px]'
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={'flex space-x-[5px] items-center md:flex-col md:space-x-[0px] md:gap-[5px]'}>
                        <WizButton
                            text={'Portfolio'}
                            onClick={() => {
                                window.open(`https://leagueoftraders.io/ko/user/${data?.id}/portfolio`)
                            }}
                            className={'text-body2 px-[20px] py-[7px] md:w-full'}
                            type={'primary'}
                        />
                        <WizSwitchButton
                            className={'text-body2 whitespace-nowrap md:w-full'}
                            state={editMode}
                            onClick={() => {
                                setEditMode(prev => !prev)
                            }}>
                            Edit Mode:
                            {editMode ? (
                                <Span className={'text-sub_blue text-ti2'}> ON</Span>
                            ) : (
                                <Span className={'text-font03 text-ti2'}> OFF</Span>
                            )}
                        </WizSwitchButton>
                    </div>
                </div>
                <div
                    className={
                        'grid grid-cols-2 border-t border-line02 mt-[30px] pt-[30px] gap-[30px] sm:flex sm:flex-col sm:items-center sm:text-center'
                    }>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Email</Text>
                        <div
                            className={
                                'flex items-center space-x-[5px] md:space-x-[0px] md:gap-[5px] md:flex-wrap sm:justify-center'
                            }>
                            <Text>{data?.email}</Text>
                            {data?.email_confirmed && <WizTag state={true}>Confirm</WizTag>}
                        </div>
                    </div>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Phone</Text>
                        <div className={'flex items-center space-x-[5px] sm:space-x-[0px] sm:justify-center'}>
                            <Text>{data?.phone || '-'}</Text>
                            {data?.phone_confirmed && <WizTag state={true}>Confirm</WizTag>}
                        </div>
                    </div>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Create At</Text>
                        <Text>{localTimeString(data?.created_at)}</Text>
                    </div>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Login Channel</Text>
                        <Text className={`${renderNetworkBgColor(data?.network)} sm:mx-auto`}>{data?.network}</Text>
                    </div>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Privacy</Text>
                        <Text>{renderPrivacyLevel(data?.privacy_level)}</Text>
                    </div>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>User Type</Text>
                        <Text>{renderUserType(data?.type)}</Text>
                    </div>

                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Shadow Ban</Text>
                        {data?.is_filtered ? (
                            <div className={'flex items-center space-x-[10px]'}>
                                <Text className={'text-font_red text-ti2'}>Ban User</Text>
                                <WizButton
                                    text={'Clear'}
                                    size={'small'}
                                    type={'red'}
                                    onClick={() => onClickShadowBan()}
                                />
                            </div>
                        ) : (
                            <div className={'flex items-center space-x-[10px]'}>
                                <Text>None</Text>
                                <WizButton
                                    text={'Ban'}
                                    size={'small'}
                                    type={'red'}
                                    onClick={() => onClickShadowBan()}
                                />
                            </div>
                        )}
                    </div>

                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Wallet Info</Text>
                        <div>
                            <div>
                                <Text>
                                    USDC :{' '}
                                    {floorBalance(
                                        data?.wallets?.wallets?.find(item => item?.coin === 'USDC')?.value || 0,
                                        1000,
                                    )}
                                </Text>
                            </div>
                            <div>
                                <Text>
                                    USDT :{' '}
                                    {floorBalance(
                                        data?.wallets?.wallets?.find(item => item?.coin === 'USDT')?.value || 0,
                                        1000,
                                    )}
                                </Text>
                            </div>
                        </div>
                    </div>

                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>League Point</Text>

                        <div className={'flex items-center gap-x-[10px]'}>
                            <Text className={'text-h3 text-font_green'}>{data?.league_points} LP</Text>
                            <WizButton
                                text={'View History'}
                                size={'small'}
                                onClick={() => pointHistoryModalRef?.current?.show()}
                            />
                        </div>
                    </div>

                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Leagues</Text>

                        <div className={'flex items-center gap-x-[10px]'}>
                            <Text className={'text-ti1'}>{data?.active_league?.length}</Text>
                            <WizButton
                                text={'View Detail'}
                                size={'small'}
                                type={'primary'}
                                onClick={() => userActiveLeagueModalRef?.current?.show()}
                            />
                        </div>
                    </div>

                    <div className={'space-y-[5px]'}>
                        <Text className={'text-ti2 text-font02'}>Tradermap Volume</Text>

                        <div className={'flex items-center gap-x-[10px]'}>
                            <WizButton
                                text={'View Volumes'}
                                size={'small'}
                                type={'blue'}
                                onClick={() => tradermapModalRef?.current?.show()}
                            />
                        </div>
                    </div>

                    <div className={'col-span-2'}>
                        <div
                            className={
                                'grid grid-cols-4 text-center border-t border-line02 pt-[30px] sm:grid-cols-2 sm:gap-[30px]'
                            }>
                            <div className={'space-y-[5px]'}>
                                <Text className={'text-ti3 text-font03'}>Referral Code</Text>
                                <div className={'flex gap-[5px] items-center justify-center'}>
                                    <Text>{data?.my_referral_code}</Text>
                                    {data?.referral_user_count === 0 && (
                                        <WizImage
                                            onClick={() => {
                                                referralEditModalRef?.current?.show()
                                            }}
                                            src={ic_edit}
                                            className={'w-[24px] cursor-pointer'}
                                        />
                                    )}
                                </div>

                                {data?.referral_user_count !== 0 && (
                                    <div>
                                        <Text
                                            className={
                                                'text-font_red text-body_comm w-[50%] mx-auto break-keep sm:w-full'
                                            }>
                                            해당 코드를 사용 중인 유저가 있어 변경 불가
                                        </Text>
                                    </div>
                                )}
                            </div>
                            <div className={'space-y-[5px]'}>
                                <Text className={'text-ti3 text-font03'}>User Wallets Balance</Text>
                                <div>
                                    <Text>${data?.wallets.total_value} </Text>
                                </div>
                            </div>
                            <div
                                onClick={() => usedMyReferralCodeRef?.current?.show()}
                                className={'space-y-[5px] cursor-pointer'}>
                                <Text className={'text-ti3 text-font03'}>Referral User Count (Click List)</Text>
                                <Text>{data?.referral_user_count}</Text>
                            </div>
                            <div className={'space-y-[5px]'}>
                                <Text className={'text-ti3 text-font03'}>Used Referral Code</Text>
                                <div
                                    className={
                                        'flex items-center space-x-[10px] justify-center cursor-pointer sm:flex-col sm:space-x-[0px] sm:gap-[5px]'
                                    }
                                    onClick={() => {
                                        if (data?.used_referral_code?.id) {
                                            goUserDetail(data?.used_referral_code?.id)
                                        }
                                    }}>
                                    <WizImage
                                        src={renderThumbnail(data?.used_referral_code?.thumbnail)}
                                        className={'w-[32px] h-[32px] rounded-full'}
                                    />
                                    <Text className={'text-left'}>
                                        {data?.used_referral_code?.name || '[No Data]'}
                                        <Span className={'block text-body_comm text-font03'}>
                                            {data?.used_referral_code?.id &&
                                                `(${shortCutString(data?.used_referral_code?.id)})`}
                                        </Span>
                                    </Text>
                                    <WizImage
                                        onClick={e => {
                                            e?.preventDefault()
                                            e.stopPropagation()
                                            changedUsedReferralCodeModalRef?.current?.show()
                                        }}
                                        src={ic_edit}
                                        className={'w-[24px] cursor-pointer'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ChangedNicknameModal
                ref={changedNicknameModalRef}
                nickname={data?.name}
                userId={data?.id}
                refetch={refetch}
            />
            <ChangedKoreanNicknameModal
                ref={changedKoreanNicknameModalRef}
                nickname={data?.nicknames}
                userId={data?.id}
                refetch={refetch}
            />
            <ChangedStatusMessageModal
                ref={changedStatusMessageModalRef}
                status={data?.status}
                userId={data?.id}
                refetch={refetch}
            />
            <ChangedUserReferralModal
                ref={referralEditModalRef}
                status={data?.my_referral_code}
                userId={data?.id}
                refetch={refetch}
            />
            <ChangedUsedReferralCodeModal
                ref={changedUsedReferralCodeModalRef}
                status={data?.used_referral_code}
                userId={data?.id}
                refetch={refetch}
            />
            <RemoveThumbnailModal ref={RemoveThumbnailRef} refetch={refetch} userId={data?.id} />
            <UsedMyReferralCodeList userId={data?.id} ref={usedMyReferralCodeRef} />
            <UserPointHistoryModal userId={data?.id} ref={pointHistoryModalRef} />
            <UserActiveLeagueModal data={data?.active_league} userId={data?.id} ref={userActiveLeagueModalRef} />
            <UserTradermapModal userId={data?.id} ref={tradermapModalRef} />
        </>
    )
}

export default UserInfoContainer
